<template>
  <main class="digital-voucher">
    <template v-if="extension.payload && extension.payload.item_name">
      <section class="digital-voucher-row first flex flex-row flex-wrap">
        <div class="offer offer-name">
          <div class="offer-label">offer name</div>
          <div class="offer-value">{{ extension.payload.item_name }}</div>
        </div>
        <div class="offer expiration">
          <div class="offer-label">expiration</div>
          <div class="offer-value">{{ expirationDate }} (midnight)</div>
        </div>
        <div class="offer uses-per-customer">
          <div class="offer-label">uses per customer</div>
          <div class="offer-value">{{ usesPerCustomer }}</div>
        </div>
      </section>

      <section class="digital-voucher-row last flex flex-row flex-wrap">
        <div class="offer description">
          <div class="offer-label">description</div>
          <div class="offer-value">{{ hasDescription }}</div>
        </div>
        <div class="offer display-image">
          <div class="offer-label">display image</div>
          <div class="offer-value">{{ hasDisplayImage }}</div>
        </div>
        <div class="offer voucher-image">
          <div class="offer-label">voucher image</div>
          <div class="offer-value">{{ hasVoucherImage }}</div>
        </div>
        <div class="offer voucher-effects">
          <div class="offer-label">effects</div>
          <div class="offer-value">{{ hasVoucherEffects }}</div>
        </div>
        <div class="offer voucher-url">
          <div class="offer-label">url</div>
          <div class="offer-value">{{ hasVoucherUrl }}</div>
        </div>
        <div class="offer voucher-disount">
          <div class="offer-label">discount id</div>
          <div class="offer-value">{{ hasVoucherDiscountId }}</div>
        </div>
      </section>
    </template>
  </main>
</template>

<script>
import { utcToZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import { mapGetters } from "vuex";

export default {
  props: {
    extension: Object
  },

  name: "digital-voucher-preview",

  computed: {
    expirationDate() {
      const expirationDate = this.extension.payload?.expiration_date;
      return expirationDate ? format(utcToZonedTime(expirationDate, this.merchantTimeZone), "MM/dd/y") : null;
    },
    hasDisplayImage(){
      const displayImage = this.extension.payload?.has_preload_image;
      return displayImage ? "yes" : "no";
    },
    hasVoucherImage(){
      const voucherImage = this.extension.payload?.has_coupon_image;
      return voucherImage ? "yes" : "no";
    },
    hasVoucherEffects(){
      const voucherEffects = this.extension.payload?.offer_effects_attributes.filter((effect) => effect.name);;
      return voucherEffects.length > 0 ? "yes" : "no";
    },
    hasVoucherUrl(){
      const voucherUrl = this.extension.payload?.product_url_attributes?.value;
      return voucherUrl ? "yes" : "no";
    },
    hasVoucherDiscountId(){
      const voucherDiscountId = this.extension.payload?.meta;
      return voucherDiscountId ? "yes" : "no";
    },
    usesPerCustomer() {
      const maxRedemptions = this.extension.payload?.max_redemptions;
      return (Number(maxRedemptions) === -1) ? "unlimited" : maxRedemptions;
    },
    hasDescription() {
      return this.extension.payload?.description ? "yes" : "no";
    },
    ...mapGetters(["merchantTimeZone"])
  }
}
</script>

<style scoped>
.digital-voucher {
  width: 100%;
}

.offer {
  padding: 5px 6px;
}
.digital-voucher {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.digital-voucher .offer-label {
  color: gray;
  font-size: .8em;
}

.digital-voucher .offer-value {
  font-size: .9em;
}
.digital-voucher-row.first .offer {

  border-left: 1px solid #128ff9;
  border-bottom: 1px solid #128ff9;
  margin-left: -1px;
  margin-bottom: -1px;
}
.digital-voucher-row.last .offer{
  border-left: 1px solid #128ff9;
  border-top: 1px solid #128ff9;
  margin-left: -1px;
  margin-top: -1px;
}
.digital-voucher-row > * {
  flex-grow: 1;
}

.digital-voucher-row:first-child {
  border-bottom: 1px solid #128ff9;
}
</style>
